/**
 * Shared constants — Single Source of Truth.
 *
 * Every magic number, threshold, label, and URL that appears in 2+ files
 * MUST live here. Components import from this file, never hardcode.
 */

// ── Session & Auth ──────────────────────────────────────────────────────
export const SESSION_WARNING_MS = 25 * 60 * 1000;  // 25 min
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000;  // 30 min (matches JWT_ACCESS_MINUTES)
export const LOGIN_PATH = '/accounts/login/';

// ── Chat ────────────────────────────────────────────────────────────────
export const CHAT_SCROLL_NEAR_BOTTOM_PX = 200;
export const CHAT_TEXTAREA_MAX_HEIGHT_PX = 200;

// ── Billing ─────────────────────────────────────────────────────────────
export const CHECKOUT_SUCCESS_PARAM = 'checkout';
export const CHECKOUT_SUCCESS_VALUE = 'success';

// ── Plans / Conversion ──────────────────────────────────────────────────
export const ANNUAL_DISCOUNT_PERCENT = 20;
export const SOCIAL_PROOF_TEXT = 'Trusted by 500+ construction professionals across Australia';
export const GUARANTEE_TEXT = '30-day money-back guarantee — no questions asked';

export const PLANS_FAQ: { question: string; answer: string }[] = [
    {
        question: 'Can I switch plans later?',
        answer: 'Yes — upgrade or downgrade anytime from your Profile → Plan Management page. Changes take effect immediately.',
    },
    {
        question: 'What happens when my free trial ends?',
        answer: 'Your card is charged automatically. You can cancel anytime before the trial ends to avoid being charged.',
    },
    {
        question: 'Do I get a refund if I cancel?',
        answer: 'We offer a 30-day money-back guarantee on all plans. Contact us within 30 days of your first payment for a full refund.',
    },
    {
        question: 'What payment methods do you accept?',
        answer: 'All major credit and debit cards via Stripe. We support Visa, Mastercard, and American Express.',
    },
    {
        question: 'Is my payment information secure?',
        answer: 'Absolutely. Payments are processed by Stripe (PCI Level 1 certified). We never see or store your card details.',
    },
];

// ── Education ───────────────────────────────────────────────────────────
export const COURSE_DESCRIPTION_MAX_LINES = 3;
export const COURSE_TITLE_MAX_LINES = 2;

// ── Networking ──────────────────────────────────────────────────────────
export const SKILLS_MAX_VISIBLE_ROWS = 2;
export const PYMK_PAGE_SIZE = 20;
